<footer class="site-footer">
	<div class="footer-top">
		<div class="container">
			<div class="footer-brand-block">
				<p class="footer-brand">NETiC Gestión</p>
				<p>
					Plataforma en la nube para negocios que buscan ordenar su gestión, centralizar información y
					trabajar de
					forma más profesional.
				</p>
			</div>
		</div>
	</div>

	<div class="footer-middle">
		<div class="container footer-middle-content">
			<div class="footer-contact">
				<p>Chivilcoy - Buenos Aires</p>
				<p>2346-406483</p>
				<p>2346-569300</p>
				<p>
					<a href="mailto:info@network-informatica.com.ar">info@network-informatica.com.ar</a>
				</p>
				<div class="footer-whatsapp">
					<a
						href="https://wa.me/5492346406483"
						target="_blank"
						rel="noopener noreferrer"
						class="social-pill social-whatsapp"
						aria-label="Abrir WhatsApp"
						title="Abrir WhatsApp"
					>
						<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
							<path d="M20.52 3.48A11.86 11.86 0 0 0 12.07 0C5.5 0 .17 5.33.17 11.9c0 2.1.55 4.16 1.59 5.98L0 24l6.3-1.65a11.85 11.85 0 0 0 5.77 1.47h.01c6.57 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.46-8.44Zm-8.45 18.33h-.01a9.88 9.88 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.64-.24-.37a9.86 9.86 0 0 1-1.52-5.29c0-5.47 4.45-9.92 9.92-9.92a9.84 9.84 0 0 1 7.03 2.92 9.84 9.84 0 0 1 2.9 7.01c0 5.47-4.45 9.92-9.92 9.92Zm5.44-7.42c-.3-.15-1.77-.87-2.04-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.15-.17.2-.35.22-.65.08-.3-.15-1.25-.46-2.39-1.46-.88-.79-1.47-1.76-1.64-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.53-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.53.08-.8.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.09 3.2 5.08 4.48.71.3 1.27.48 1.7.62.72.23 1.37.2 1.88.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.08-.12-.27-.2-.57-.35Z" />
						</svg>
					</a>
				</div>
			</div>

			<div class="footer-links">
				<a href="#beneficios">Beneficios</a>
				<a href="#funcionalidades">Funcionalidades</a>
				<a href="#planes">Planes</a>
				<a href="#faq">Preguntas frecuentes</a>
			</div>
		</div>
	</div>

	<div class="footer-bottom">
		<div class="container">
			<p class="footer-copy">
				Copyright {{ currentYear }} -
				<a href="https://www.network-informatica.com.ar" target="_blank" rel="noopener noreferrer">Network
					Informática</a>
				| Todos los derechos reservados
			</p>
		</div>
	</div>
</footer>